/* eslint-disable @typescript-eslint/no-require-imports */

export const IllusBowlEmptySmall = [
  require('./Illus-BowlEmpty-Small.png'),
  require('./Illus-BowlEmpty-Small@2x.png'),
];
